var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-select"},[_c('p',{staticClass:"app-select__label"},[_vm._v(_vm._s(_vm.getTranslatedText('Select the event')))]),_c('p',{staticClass:"app-select__text"},[_vm._v(_vm._s(_vm.getTranslatedText('current jackpot'))+": "+_vm._s(_vm.formatPrice(_vm.currentJackpot)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }